import styled from 'styled-components';

const FooterStyle = styled.footer`
	--footerPadTB: var(--sp8x);

	--footerBorderDistance: var(--sp4x);
	--footerBlockSize: 50%;

	--footerMenuItemDistance: var(--sp2x);
	--footerMenuItemWidth: calc(50% - var(--footerMenuItemDistance));

	--footerContactDataBlockMTop: var(--sp2x);

	--footerSocialIconSize: var(--sp4x);

	padding: var(--footerPadTB) var(--contPaddingLR);
	background-color: var(--backgroundSecondaryColor);

	.footer-top-wrapper {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.footer-block {
		width: var(--footerBlockSize);

		.menu-item-block {
			display: flex;
			flex-wrap: wrap;
			gap: var(--footerMenuItemDistance);
		}

		&.left {
			height: fit-content;
		}

		&.right {
			display: flex;
			justify-content: flex-end;
			border-left: 2px solid var(--textSecondaryColor);
		}
	}

	.social-block {
		margin-top: var(--sp4x);
	}

	.svg-block {
		display: flex;
		gap: var(--sp2x);
		margin-top: var(--footerContactDataBlockMTop);

		.icon-container {
			--iconSize: var(--footerSocialIconSize);
		}
	}

	.icon-wrap {
		transition: transform var(--trTime) ease-out;
	}

	.footer-menu-item {
		width: var(--footerMenuItemWidth);
	}

	.footer-contact-data-block {
		display: flex;
		flex-direction: column;
		gap: var(--sp0-5x);
		margin-top: var(--footerContactDataBlockMTop);
	}

	.footer-bottom-wrapper {
		border-top: 2px solid var(--textSecondaryColor);
		margin-top: var(--footerBorderDistance);
	}

	.footer-bottom-text {
		text-align: center;
		margin-top: var(--footerBorderDistance);
	}

	.office-name {
		margin-top: var(--footerContactDataBlockMTop);
	}

	/* //! Hover Effect */
	@media (pointer: fine) {
		@media (hover: hover) {
			.hover-line {
				position: relative;

				&:before {
					position: absolute;
					top: 100%;
					left: 0;
					display: block;
					content: '';
					width: 0%;
					height: 2px;
					background-color: var(--textSecondaryColor);
					transition: width var(--trTime) ease-out;
				}

				&:hover {
					&:before {
						width: 100%;
					}
				}
			}

			.icon-wrap {
				&:hover {
					transform: scale(1.2);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--footerPadTB: var(--sp6x);
		--footerSocialIconSize: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--footerSocialIconSize: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--footerMenuItemWidth: 100%;
		--footerPadTB: var(--sp5x);
		--footerSocialIconSize: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--footerPadTB: var(--sp4x);
		--footerBlockSize: 100%;
		--footerSocialIconSize: var(--sp3x);

		.footer-block {
			&.right {
				border-left: unset;
				border-top: 2px solid var(--textSecondaryColor);
				justify-content: center;
				margin-top: var(--footerBorderDistance);
				padding-top: var(--footerBorderDistance);
			}
		}

		.footer-our-contacts,
		.footer-address,
		.footer-email,
		.footer-phone,
		.footer-menu-item {
			text-align: center;
		}

		.social-block {
			display: flex;
			justify-content: center;
			border-top: 2px solid var(--textSecondaryColor);
			margin-top: var(--footerBorderDistance);
			padding-top: var(--footerBorderDistance);
		}

		.social-inner-block {
			width: fit-content;
		}

		.follow-us {
			text-align: center;
		}

		.svg-block {
			justify-content: center;
		}
	}
`;

export default FooterStyle;
